<valio-cx-navigation-ui
  [node]="node$ | async"
  [mainNavigation]="true"
  [mainNavigationProducts]="true"
></valio-cx-navigation-ui>
